import axios from "axios";

export const state = {
    previousbalances: [],
};

export const getters = {
    previousbalances: state => state.previousbalances,
};

export const mutations = {
    setBalances(state, newValue) {
        state.previousbalances = newValue
    },
};

export const actions = {
    fetchPreviousBalances({ commit }) {
        axios.get('/previousbalances').then(res => {
            commit('setBalances', res.data.balances);
        })
    },
};
